
<template>
     <!-- <div v-if="dotsLoading" class="mt-2">
		<div class="flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white">
			<dots-loader/>
		</div>
	</div> -->
	<div class="table-data-root">
	<div class="bg-white table-card-shell tableCornerRadius">
	<div class="table-card-inner" :class="pageData!=undefined && pageData == 4 ? 'fixHeightTable flex flex-col justify-between':''">
		<div class="table-container table-container-fit">
			<div class="table-header-wrap">
			<table class="table-fit-card table-header-table" :style="tableResizeStyle">
			<colgroup>
				<col v-for="presentColumn in columnNames" :key="'h-'+presentColumn" :style="columnStyle(presentColumn)" />
			</colgroup>
			<thead>
				<tr class="table-header-row">
				<th scope="col" v-for="presentColumn in columnNames" :key="presentColumn" class="bg-white capitalize resizable-th" :class="getColumnHeadWidth(presentColumn)" :style="columnStyle(presentColumn)" @click="onHeaderClick(presentColumn); doFalse()" @mouseout="doFalse()">
                 <div class="flex table-header-label-wrap" :class="getPaddingForColumn(presentColumn)">
                        <div class="table-header-label" @mousemove="headerToolTip(presentColumn, $event)">{{ getColumnLabel(presentColumn) }}</div>
                        <div class="sort cursor-pointer" :class="className == presentColumn ? classSort : 'opacity-50'" v-if="getColumnLabel(presentColumn) != ''"></div>
                </div>
				<span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, presentColumn)"></span>
                </th>
				</tr>
				<tr v-if="visibility" class="table-filter-row">
                    <td v-for="(presentColumn, index) in columnNames" :key="index" :class="getColumnHeadWidth(presentColumn)" :style="columnStyle(presentColumn)">
                        <!-- Dropdown -->
                        <select v-if="isColumnArrayPresent(presentColumn)" class="statusFilter" :class="[filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect',selectInputStyling(presentColumn)]" v-model="filters[presentColumn]">
                            <option :value="filters.presentColumn" selected hidden disabled>Select</option>
                            <option class="optionColors" v-for="option in getDropdownOptionsForFilter(presentColumn)" :key="option.id" :value="option.id">{{ option.value }}</option>
                        </select>
						<select v-if="presentColumn=='Frequency'" class="statusFilter" :class="[filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect',selectInputStyling(presentColumn)]" v-model="filters[presentColumn]">
                            <option :value="filters.presentColumn" selected hidden disabled>Select</option>
                            <option class="optionColors" v-for="option in dbFrequency" :key="option.value" :value="option.value">{{ option.key }}</option>
                        </select>
                        <!-- No Input -->
                        <div v-else-if="isFilterNotNecessary(presentColumn)"></div>
                        <!-- Text Input -->
                        <input v-else type="text" class="searchForInputBoxStyling" v-model.trim="filters[presentColumn]" placeholder="Search" />
                    </td>
                </tr>
			</thead>
			</table>
			</div>
			<div class="table-body-scroll">
			<table class="table-fit-card" :style="tableResizeStyle">
			<colgroup>
				<col v-for="presentColumn in columnNames" :key="'b-'+presentColumn" :style="columnStyle(presentColumn)" />
			</colgroup>
			<tbody v-if="loadData == true">
				<tr class="cursor-pointer empty rowHeight">
					<td class="relative h-5" :colspan="columnNames.size">
						<div class="flex items-center justify-center w-full h-16 skeleton">
							<dots-loader/>
						</div>
					</td>
				</tr>
			</tbody>

			<tbody :class="pageData!=undefined && pageData == 4 ? 'emptyFixed':''" v-else-if="sortedData.length == 0">
                <tr class="cursor-pointer rowHeight">
                    <td class="relative h-10" :colspan="columnNames.size">
                        <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                    </td>
                </tr>
            </tbody>
			
			<tbody class="nonEmptyTable" v-else>
                <tr v-for="(row, index) in sortedData" :key="row" class="cursor-pointer rowHeight hoverEffectForCompleteRow" >
                    <td v-for="presentColumn in columnNames" :key="presentColumn" @mouseout="doFalse()"  @click="clickedOnActionButton(row, index, presentColumn)" class="cursor-pointer relative" :class="getColumnHeadWidth(presentColumn)" :style="columnStyle(presentColumn)">
                        <!-- <div class=" ml-3 rounded h-5 w-24" v-if="row[presentColumn] == ''">{{ '-' }}</div> -->
                        <div v-if="isColumnPresentForLabel(presentColumn)" class="flex justify-center">
                            <div class="flex items-center justify-center rounded h-5 w-24" :class="bgColorForStatus(row[presentColumn])">
                                <div :class="textColorForStatus(row[presentColumn])">
                                    {{getStatusLabelFromColumn(row[presentColumn],presentColumn)}}
                                </div>
                            </div>
                        </div>
						 <div v-else-if="presentColumn == 'statusCode'" class="flex justify-center">
                            <div class="flex items-center justify-center rounded h-5 w-32 px-2 whitespace-nowrap" :class="bgColorForFindingStatus(row[presentColumn])">
                                <div :class="textColorForFindingStatus(row[presentColumn])">
									<!-- {{   row[presentColumn],presentColumn }} -->
                                    {{getStatusLabelFromColumn(row[presentColumn],presentColumn)}}
                                </div>
                            </div>
                        </div>
						 <div v-else-if="presentColumn == 'findingStatus'" class="flex justify-center">
                            <div class="flex items-center justify-center rounded h-5 w-24 whitespace-nowrap" :class="bgColorForFindingStatus(row[presentColumn])">
                                <div :class="textColorForFindingStatus(row[presentColumn])">
									<!-- {{   row[presentColumn],presentColumn }} -->
                                    {{getStatusLabelFromColumn(row[presentColumn],presentColumn)}}
                                </div>
                            </div>
                        </div>
						<div v-else-if="presentColumn == 'taskStatus' || presentColumn == 'statusCode'" class="flex justify-center">
                            <div class="flex items-center justify-center rounded h-5 w-32 px-2 whitespace-nowrap" :class="colorAuditBg(row[presentColumn])">
								<div :class="colorAuditText(row[presentColumn])">
									{{getStatusLabelFromColumn(row[presentColumn],presentColumn)}}
								</div>
							</div>
						</div>
						<div v-else-if="presentColumn=='Frequency'">
							<div class="table-ellipsis" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
								{{getFrequency(row[presentColumn])}}
							</div>
						</div>
						<div v-else-if="presentColumn == 'findingCategory'" class="table-ellipsis text-center" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
							{{getStatusLabelFromColumn(row[presentColumn],presentColumn)}}
						</div>
						<div v-else-if="presentColumn == 'startDate' || presentColumn == 'endDate'  " class="table-ellipsis" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
							{{changeDateFormat(row[presentColumn])}}
                        </div>
						<div v-else-if="presentColumn == 'auditPeriod' " class="table-ellipsis w-36" :class="presentColumn == 'startDate'?'pl-3':''" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
							{{row[presentColumn]}}
                        </div>
						<div v-else-if="presentColumn =='dueDate'" class="flex items-center justify-center w-20 rounded h-5 table-ellipsis mx-auto" :class="shouldStyleDueDate(row) ? colorForDueDate(row[presentColumn]) : ''" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
							{{ row[presentColumn] }} 
						</div>
						<div v-else-if="presentColumn == 'frameWorkControl'" :class="getBorder()" class="text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center" >
							{{row[presentColumn]}}
						</div>
						<div v-else-if="checkuserData(presentColumn)">
                            <div v-if="presentColumn == 'team' "><p class="cursor-pointer text-xs table-ellipsis" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">{{row[presentColumn] }}</p></div>
							 <div v-else-if="presentColumn == 'entity'"><p class="cursor-pointer text-xs table-ellipsis" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">{{row[presentColumn] }}</p></div>
							 <div v-else-if="presentColumn == 'auditor'">
								<div class="cursor-pointer text-xs table-ellipsis" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
									{{ getOwnerName(row[presentColumn]) }}
								</div>
							</div>
							<div v-else-if="presentColumn == 'assignee'">
								<div class="cursor-pointer text-xs table-ellipsis" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
									{{ row[presentColumn] }}
								</div>
							</div>
							<!-- <div v-if="pop == true && sortedData[tipIndex][presentColumn] == tipText && tipColumn == presentColumn && tipIndex == index">
                                    <tool-tip :columnName="presentColumn" :tipText="getOwnerName(tipText)" :styling="styling"></tool-tip>
                            </div> -->
                        </div>
						<div v-else-if="presentColumn=='deleteIcon'">
                            <div class="flex justify-start items-center h-5">
                                    <img src="@/assets/deleteIcon.svg" class="h-5 w-5 cursor-pointer" @click="clickedOnDeleteButton(row)"/>
                                </div>
                        </div>
                        <div v-else-if="presentColumn == 'actionButtonAtAudits'">
								<!-- <div 
                                    class="action-button-container relative"
									@click.stop="calculateDropdownPosition($event,presentColumn,index)"
                                    :data-row-index="index"
                                >
                                    <div class="flex justify-end items-center w-5 h-5">
                                    <img src="@/assets/ActionIcon.svg" class="h-5 w-5 cursor-pointer" />
                                    </div>
                                    
                                    <ul
                                    v-if="showDropDown && selectedRowIndex == index"
                                    class="card shadow-sm absolute cursor-pointer z-50"
                                    :class="[
                                        dropdownDirection[index] === 'up' ? 'dropdown-up' : 'dropdown-down',
                                        'min-w-[150px]'
                                    ]"
                                    >
                                    <li
                                        class="cursor-pointer border-b border-lightgrey hover:bg-lightgrey h-7 flex items-center"
                                        v-for="(option, i) in optionsValue"
                                        :key="i"
                                        @click.stop="optionClickedOnAction(option.value, row)"
                                    >
                                        <div class="flex items-center" v-if="option.value == 'Edit'">
											<img src="@/assets/editIcon.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
											{{ option.value }}
										</div>
										<div class="flex items-center" v-if="option.value == 'View'">
											<img src="@/assets/view.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                            {{ option.value }}
                                        </div>
										<div class="flex items-center" v-if="option.value == 'Controls'">
											<img src="@/assets/controls.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                            {{ option.value }}
                                        </div>
										<div class="flex items-center" v-if="option.value == 'Reports'">
											<img src="@/assets/reports.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                            {{ option.value }}
                                        </div>
                                    </li>
                                    </ul>
                                </div> -->
								<Button type="button" icon="pi pi-ellipsis-v" @click.stop="actionButtonToggle($event,index)" style="background-color: white; color: black; border: white;"/>

								<Menu :ref="'menu' + index" :model="actionButtonItems(row)" :popup="true" class="menuWidth" appendTo="body"
/>

                        </div>
						<!-- <div v-else-if="presentColumn == 'actionButtonAtFindings'">
                            <fieldset>
                                <div class="flex justify-end items-center w-5 h-5 ImageResponsive">
                                    <img src="@/assets/ActionIcon.svg" class="h-5 w-5 cursor-pointer" />
                                </div>
                                <ul class="card shadow-sm zIndexingForActionDropDown absolute cursor-pointer actionButtonStyling" v-if="showDropDown && selectedRowIndex == index" >
                                    <li class="cursor-pointer border-b border-lightgrey hover:bg-lightgrey h-7 flex items-center" v-for="(option, index) in ActionButtonAtFindings" @click="optionClickedOnActionAtFindings(option.value,row)" :key="index" >
                                        
										<div class="flex items-center" v-if="option.value == 'View'">
											<img src="@/assets/view.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
											{{ option.value }}
										</div>
                                    </li>
                                </ul>
                            </fieldset>
                        </div>
						<div v-else-if="presentColumn == 'actionButtonAtControlsTasks'">
                            <fieldset>
                                <div class="flex justify-end items-center w-5 h-5 ImageResponsive">
                                    <img src="@/assets/ActionIcon.svg" class="h-5 w-5 cursor-pointer" />
                                </div>
                                <ul class="card shadow-sm zIndexingForActionDropDown absolute cursor-pointer actionButtonStyling" v-if="showDropDown && selectedRowIndex == index" >
                                    <li class="cursor-pointer border-b border-lightgrey hover:bg-lightgrey h-7 flex items-center" v-for="(option, index) in ActionButtonAtControlsTasks" @click="optionClickedOnActionAtControlsTasks(option.value,row)" :key="index" >
                                        
										<div class="flex items-center" v-if="option.value == 'View'">
											<img src="@/assets/view.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
											{{ option.value }}
										</div>
                                    </li>
                                </ul>
                            </fieldset>
                        </div>
						<div v-else-if="presentColumn == 'ActionButtonAtFindingsTasks'">
                            <fieldset>
                                <div class="flex justify-end items-center w-5 h-5 ImageResponsive">
                                    <img src="@/assets/ActionIcon.svg" class="h-5 w-5 cursor-pointer" />
                                </div>
                                <ul class="card shadow-sm zIndexingForActionDropDown absolute cursor-pointer actionButtonStyling" v-if="showDropDown && selectedRowIndex == index" >
                                    <li class="cursor-pointer border-b border-lightgrey hover:bg-lightgrey h-7 flex items-center" v-for="(option, index) in ActionButtonAtFindingsTasks" @click="optionClickedOnActionAtActionTasks(option.value,row)" :key="index" >
                                        
										<div class="flex items-center" v-if="option.value == 'View'">
											<img src="@/assets/view.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
											{{ option.value }}
										</div>
                                    </li>
                                </ul>
                            </fieldset>
                        </div> -->

                        <div v-else>
                            <div class="table-ellipsis" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
                                    {{ row[presentColumn] }}
                            </div>
                            <!-- <div v-if="pop == true && sortedData[tipIndex][presentColumn] == tipText && tipColumn == presentColumn && tipIndex == index">
                                <tool-tip :columnName="presentColumn" :tipText="tipText" :styling="styling"></tool-tip>
                            </div> -->
                        </div>
                    </td>
                </tr>
            </tbody>
		</table>
		</div>
		</div>
		<pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedData" :pageData="pageData"></pagination>
	</div>
	</div>
	</div>
</template>
<style scoped>

/* Base container for action button */
.action-button-container {
  position: relative;
  display: inline-block;
}

/* Dropdown positioning classes */
.dropdown-up {
  bottom: calc(100% +5px);
  position: absolute;
  right: 0;
  z-index: 999;
  background: white;
  min-width: 150px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.dropdown-down {
  top: calc(100% +5px);
  position: absolute;
  right: 0;
  z-index: 999;
  background: white;
  min-width: 150px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Card and list item styling */
.card {
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 100px;
  width: max-content;
}

.card li {
  padding: 8px 12px;
  white-space: nowrap;
  border-bottom: 1px solid #e9e9e9;
}

.card li:hover {
  background-color: #f5f5f5;
}

.card li:last-child {
  border-bottom: none;
}

.bgdarkred{
 background-color: rgba(192, 0, 0, 0.2);
}

.table-container {
  width: 100%;
  overflow: hidden;
}
table {
  table-layout: fixed;
}
th, td {
  overflow: hidden;
  white-space: nowrap;
  word-break: normal;
  overflow-wrap: normal;
  text-overflow: ellipsis;
  text-align: left;
  vertical-align: middle;
}
th.resizable-th {
  overflow: visible;
}


.inputboxstylingForSelect .optionColors{
   color : #4D4D4D !important;
}
.fixHeightTable{
	height: 353px !important;
}
.emptyFixed:last-child  {
	border-bottom: 1px solid #e9e9e9;
}
.nonEmptyTable:last-child  {
	border-bottom: 1px solid #e9e9e9;
}
.ellipsis-container {
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	line-height: 1.5em;
	max-height: 3em;
}
.table-ellipsis {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: normal;
	overflow-wrap: normal;
	max-width: 100%;
}
.statusFilter{
	width : 99px !important
}
.table-filter-row .searchForInputBoxStyling,
.table-filter-row .statusFilter {
	width: 100%;
	max-width: 100%;
	min-width: 0;
	box-sizing: border-box;
	white-space: nowrap;
}
.statusWidthForTask{
	width : 8rem !important; /* match status td w-32 */
}
.widthForStatusCode{
	width: 135px !important;
}
.actionButtonStyling {
    left: -18px;
}
.lastChild:last-child {
    border: 0px;
}
/* .rowHeight{
  height: 40px;
} */
 .actionButtonWidth{
	width : 48px;
	max-width: 48px;
	min-width: 48px;
	padding-left: 4px !important;
	padding-right: 4px !important;
 }
.titleColumnWidth{
	width: 14rem;
	min-width: 0;
	max-width: none;
}
.statusColumnWidth{
	width: 144px;
	min-width: 0;
	max-width: none;
	padding-left: 8px !important;
	padding-right: 8px !important;
}
 .numberBorder{
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
}
.numberNavy{
    border-left: 1px solid #1976d2;
    border-width: 2px;
}
.zIndexingForActionDropDown{
	z-index : 65;
	width : 100px;
	margin-left : -40px;
	position: absolute;
    left: -8px;
}
.zIndexingForActionDropDown1{
	z-index : 65;
	width : 100px;
	margin-left : -40px;
	position: fixed;
}
.pendingEvidence{
    background-color: #8600f040;
}
.pendingEvidenceFill{
    background-color: #8600F0 !important;
}
.forReviewFill{
    background-color: #085B96 !important;
    color: #ffffff !important;
}
.textColorWhite {
    color: #ffffff;
}
.evidenceUpload{
    background: rgba(25,118,210,0.24);
}
.widthFor1stAudit{
	width: 98px;
    margin-left: -3px;
}
.marginForIdInFilters{
	margin-left : -6px;
}

.width25{
	width : 25%;
}

</style>
<script lang="ts">
import { emitter,toast } from '@/main';
import _ from 'lodash';
import { defineComponent } from 'vue';
import toolTip from '@/components/toolTip.vue';
import pagination from '@/components/pagination.vue'
import dotsLoader from '@/components/dotsLoader.vue';
import { mapGetters } from 'vuex';
import Menu from 'primevue/menu';
import Button from 'primevue/button';
import { columnResizeMixin } from '@/mixins/columnResizeMixin';

export default defineComponent({
	mixins: [columnResizeMixin],
	props: ['tableRowData', 'headersData','pageData','loadData'],
	data(): any {
		return {
			dropdownDirection: {}, // Object to track dropdown directions
			tableHead: [],
			tableRow: [],
			searchTableRow: [],
			visibility: false,
			className: '',
			classSort: '',
			currentSort: 'name',
			currentSortDir: 'asc',
			currentPage: '',
			pageSize: '',
			dynamicPagination: '',
			pop: false,
			styling: { left: '', bottom: '' },
			tipText: '',
			tipColumn: '',
			tipIndex: '',
			filters: {},
			showDropDown: false,
			selectedRowIndex: '',
			optionsUserArray : [],
			teamObject : [],
			locationObject : [],
			showBlock: false,
            dynamicLeftPosition: 0,
            dynamicTopPosition: 0,
      		isDropdownUp: false,
			statusType: [
				{
					id: 10401,
					value: 'Not started'
				},
				{
					id: 10402,
					value: 'In progress'
				},
				{
					id: 10403,
					value: 'Closed'
				}
			],
			actionButtonItems(row:any) {
				return[
                {
                    id: 1,
                    label: 'Edit',
					icon: 'pi pi-pencil',
					command: () => this.optionClickedOnAction('Edit', row)
                },
                {
                    id: 2,
                    label: 'View',
					icon: 'pi pi-eye',
					command: () => this.optionClickedOnAction('View', row)
                },
                {
                    id: 5,
                    label: 'Controls',
					icon: 'pi pi-cog',
					command: () => this.optionClickedOnAction('Controls', row)	
                },
				{
					id: 6,
					label: 'Reports',
					icon: 'pi pi-file',
					command: () => this.optionClickedOnAction('Reports', row)	

				}
            ]
			},
			columns: [
                { key: 'auditId', value: 'Audit ID' },
                { key: 'title', value: 'Title' },
                { key: 'auditPeriod', value: 'Audit Period' },
                { key: 'startDate', value: 'Start Date' },
                { key: 'endDate', value: 'End Date' },
                { key: 'auditor', value: 'Auditor' },
				{ key: 'auditor1', value: 'Auditor' },
                { key: 'auditStatus', value: 'Status' },
				{ key: 'findingStatus', value: 'Status' },
				{ key: 'findingId', value: 'Id' },
				{ key: 'taskId', value: 'ID' },
				{ key: 'taskStatus', value: 'status' },
				{ key: 'findingComment', value: 'finding' },
				{ key: 'auditName', value: 'Audit' },
				{ key: 'findingCategory', value: 'Category' },
				{ key: 'teamName', value: 'team' },
				{ key: 'entityName', value: 'Location' },
				{ key: 'teamName1', value: 'team' },
				{ key: 'entityName1', value: 'Location' },
				{ key: 'controlNumber', value: 'control' },
                { key: 'controlName', value: 'title' },
                { key: 'frameworks', value: 'framework' },
				{ key: 'frameWorkControl', value: 'control' },
				{ key: 'statusCode', value: 'Status' },
				{ key: 'department', value: 'Team' },
				{ key: 'assignee', value: 'Assigned To' },
				{key:'entity',value:'Location'},
				{key:'dueDate',value:'Due Date'}
				
            ],
			dropdownOptions:[
				{
                    key: 'auditStatus',
                    value: [
                       	{
							id: 10401,
							value: 'Not started'
						},
						{
							id: 10402,
							value: 'In progress'
						},
						{
							id: 10403,
							value: 'Closed'
						},
						{
							id: 10418,
							value: 'Terminated'
						},
                    ]
                
				},
				{
                    key: 'findingStatus',
                    value: [
                       	{
							id: 10401,
							value: 'Open'
						},
						{
							id: 10415,
							value: 'In Review'
						},
						{
							id: 10402,
							value: 'In Progress'
						},
						{
							id: 10406,
							value: 'Partial'
						},
						{
							id: 10403,
							value: 'Closed'
						},
						{
							id: 10418,
							value: 'Terminated'
						},
                    ]
                
				},
				{
                    key: 'taskStatus',
                    value: [
						{
							id: 10401,
							value: 'Not Started'
						},
						{
							id: 10414,
							value: 'Pending Evidence'
						},
						{
							id: 10415,
							value: 'InReview'
						},
						{
							id: 10416,
							value: 'Evidence Uploaded'
						},
						{
							id: 10403,
							value: 'Completed'
						},
						{
							id: 10417,
							value: 'Not Applicable'
						},
						{
							id: 10418,
							value: 'Terminated'
						},

					]
                
				},
				{
					key:'findingCategory',
					value: [
						{
							id: 1,
							value: 'Minor'
						},
						{
							id: 2,
							value: 'Major'
						},
						{
							id: 3,
							value: 'OFI'
						},
						{
							id: 4,
							value: 'Observation'
						}
					]
				},
				{
					key:'statusCode',
					value: [
						{
							id: 10401,
							value: 'Open'
						},
						{
							id: 10402,
							value: 'In Progress'
						},
						{
							id: 10408,
							value: 'Approval'
						},
						{
							id: 10419,
							value: 'ForReview'
						},
						{
							id: 10415,
							value: 'InReview'
						},
						{
							id: 10403,
							value: 'Completed'
						},
						{
							id: 10418,
							value: 'Terminated'
						},
						{
							id:10420,
							value:'Failed'
						}
						
					]
				}
			],
			// actionButtonRow:{}
			
		};
	},
	components: {
		toolTip,
		pagination,
		dotsLoader,
		Menu,
		Button
	},
	// async mounted() {
	// 	this.initialize();
	// 	emitter.on('visible', (isBoolean: any) => {
	// 		this.visibility = isBoolean;
	// 		this.visibility == false ? (this.filters = {}) : '';
	// 	});
	// },
	computed: {
		...mapGetters({ dbFrequency: 'dbFrequency' }),
		sortedData: function (): any {
			return [...this.tableRow]
				.filter((row: any) => {
					for (const key in this.filters) {
						const inputValue = this.filters[key];
						if (inputValue !== '' && row[key]) {
							if (Number.isInteger(row[key])) {
								if (row[key] !== Number(inputValue)) {
									return false;
								}
							} else {
								if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
									return false;
								}
							}
						}
					}
					return true;
				})
				.sort((a, b) => {
					let modifier = 1;
					if (this.currentSortDir == 'desc') modifier = -1;
                    if(this.currentSort=='taskId'){
						const aVal = (a[this.currentSort] ?? '').toString();
						const bVal = (b[this.currentSort] ?? '').toString();
                        const aNumMatch = aVal.match(/\d+$/);
                        const bNumMatch = bVal.match(/\d+$/);
                        if (aNumMatch && bNumMatch) {
                            const aNum = parseInt(aNumMatch[0], 10);
                            const bNum = parseInt(bNumMatch[0], 10);
                            if (aNum < bNum) return -1 * modifier;
                            if (aNum > bNum) return 1 * modifier;
                            return 0;
                        }
						if (aVal < bVal) return -1 * modifier;
						if (aVal > bVal) return 1 * modifier;
                    }
					else{
                        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    }
					return 0;
				})
				.filter((row, index) => {
					this.dynamicPagination = index + 1;
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
		},
		columnNames: function (): any {
            const names = new Set();
            for (const key of this.headersData) {
                if (key != 'entityId' && key != '_id') names.add(key);
            }
            return names;
        },
		// actionKeys: function():any{
		// 	let startArray = [1,3,4,5,6];
		// 	let progressArr = [2,4,5,6];
		// 	let mainArr :any
		// 	if(this.actionButtonRow.auditStatus == 10401){
		// 		mainArr = startArray
		// 	}else{
		// 		mainArr = progressArr;
		// 	}
		// 	return this.optionsValue.filter((obj:any)=>{return mainArr.includes(obj.id)})
		// }
	},
	async mounted() {
		this.initialize();
		emitter.on('visible', this.onGlobalFilterVisible);
		emitter.on('*', (type, booleanValue) => {
        	if (type == 'apps-sidemenubar' || type == 'toggle-sidebar') {
        		this.showDropDown == true ? (this.showDropDown = false) : '';
        	} else {
        		if (this.showBlock === true && type != 'deActiviteToolTip') {
        			this.showDropDown == true ? (this.showDropDown = booleanValue) : '';
        		} else if (this.showBlock === false) {
        			this.showDropDown == true ? '' : (this.showDropDown = booleanValue);
        			this.showBlock = true;
        		}
        	}
        });
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
		document.addEventListener('click', this.handleClickOutside);
	},
	beforeUnmount() {
        // Remove click outside listener
        document.removeEventListener('click', this.handleClickOutside);
		emitter.off('visible', this.onGlobalFilterVisible);
    },
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	watch: {
		visibility(newValue) {
			if (newValue == false) {
				this.initialize();
			}
		},
		tableRowData: {
			handler(newVal, oldVal) {
				this.tableRow = this.tableRowData;
				this.initialize();
			},
			deep: true
		}
	},
	methods: {
		getResizeColumnNames(): string[] {
			return Array.from(this.columnNames || []);
		},
		isInsideDetailsModal() {
			const root = this.$el as HTMLElement;
			if (!root || typeof root.closest !== 'function') {
				return false;
			}
			const overlay = document.querySelector('.details-modal-overlay') as HTMLElement | null;
			if (overlay && overlay.contains(root)) {
				return true;
			}
			return !!(root.closest('.details-modal') || root.closest('.details-in-modal') || root.closest('.details-modal-body'));
		},
		onGlobalFilterVisible(isBoolean: any) {
			const overlay = document.querySelector('.details-modal-overlay');
			const root = this.$el as HTMLElement;
			if (overlay && root && typeof overlay.contains === 'function' && !overlay.contains(root)) {
				return;
			}
			this.visibility = isBoolean;
			this.visibility == false ? this.filters = {}:'';
		},
	actionButtonToggle(event: any, index: number) {
		let menu = this.$refs['menu' + index];
		if (Array.isArray(menu)) menu = menu[0];
		if (menu && typeof menu.toggle === 'function') {
			menu.toggle(event);
		}
	},
	shouldStyleDueDate(row:any) {
		const status = row.taskStatus ?? row.statusCode;
		return status != 10403 && status != 10418;
	},
	colorForDueDate(date: any) {
		
		if (!date) return '';

		const [day, month, year] = date.split('-').map(Number);
		const due = new Date(year, month - 1, day);

		if (isNaN(due.getTime())) return '';

		const today = new Date();

		due.setHours(0, 0, 0, 0);
		today.setHours(0, 0, 0, 0);

		if (due < today) {
			return "bgdarkred border-solid border text-darkred font-semibold flex justify-center items-center text-xs";
		}
		return '';
	},
	getFrequency(data:any){
			let d = this.dbFrequency.find((obj:any)=>obj.value == data);			
			if(d!=undefined){
				return d.key
			}
			else{
				return 'N/A'
			}
		},
		handleResize() {
			const currentWidth = window.innerWidth;
			// Check if the width is less than or equal to 80%
			if (currentWidth >= (window.screen.width * 0.8)) {
				this.showDropDown = false;
			this.showBlock = false // Close the dropdown
			}
			// Repeat for other widths if needed
			else if (currentWidth >= (window.screen.width * 0.7)) {
				this.showDropDown = false;
			}
			else if (currentWidth >= (window.screen.width * 0.6)) {
				this.showDropDown = false;
			}
			else if (currentWidth >= (window.screen.width * 0.5)) {
				this.showDropDown = false;
			}
		},
		calculateDropdownPosition(event:any,column:any,index:any) {
			if (column == 'actionButtonAtAudits') {
				if (!this.dropdownDirection) {
                    this.dropdownDirection = {};
                }
                this.calculateDropdownDirection(index.toString());
                if (this.selectedRowIndex === index) {
                    this.showDropDown = !this.showDropDown;
                } else {
                    this.showDropDown = true;
                    this.selectedRowIndex = index;
					// this.actionButtonRow = rowData
                }
            }
			this.showBlock = false;
			const { clientX, clientY } = event;

			// Calculate the desired position (you might want to adjust this logic)
			this.dynamicLeftPosition = clientX-40;
			const offset = 15; // Adjust this value as needed
            this.dynamicTopPosition = clientY + offset; // Example adjustment
			
			// Optionally, handle boundary checks here
		},
		calculateDropdownDirection(index: string) {
            const actionButton = document.querySelector(`[data-row-index="${index}"]`);
            if (!actionButton) return;

            const buttonRect = actionButton.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            const estimatedDropdownHeight = 80; 
          
            const taskbarBuffer = 50;
            const visibilityBuffer = 20;
            const spaceBelow = windowHeight - buttonRect.bottom - taskbarBuffer;
            this.dropdownDirection[index] = spaceBelow < (estimatedDropdownHeight + visibilityBuffer) ? 'up' : 'down';
        },
		isNearBottom(index:any) {
			if(((index == 0)||(index == 1))&&((this.sortedData.length == 1)||(this.sortedData.length == 2))){
				return false;
			}else{
				return index >= this.sortedData.length - 2;
			}
			
		},
  
		changeDateFormat(date: any) {
			if (date.includes('-')) {
				let dateParts = date.split('-');
				if (dateParts.length === 6) {
				let startDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
				let endDate = `${dateParts[5]}/${dateParts[4]}/${dateParts[3]}`;
				return `${startDate} - ${endDate}`;
				} else if (dateParts.length === 3) {
				return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
				}
			}
			return date.split('-').reverse().join('/');
		},
		getBorder(){
            return `numberBorder numberNavy`
        },
		getPaddingForColumn(column:any){
            if(column=='findingStatus' || column=='auditStatus' || column=='taskStatus' || column == 'statusCode'){
                return 'justify-center items-center'
            }else if(column=='auditPeriod'){
				return 'pl-4'
			}
			else if(column == 'findingCategory'){
                return 'justify-center items-center'
            }
			else if(column == 'dueDate') {
				return 'justify-center items-center'
			}
        },
		clickedOnDeleteButton(rowData:any){
            emitter.emit('deleteRowFromTable',rowData)
        },
		 colorAuditText(status: any) {
			if (status == 10401) {
				return ['font-semibold text-disabledgrey'];
			} else if (status == 10402 || status==10421) {
				return ['font-semibold text-yellow'];
			} else if (status == 10403 || status==10422) {
				return ['font-semibold text-lightgreen'];
			} else if(status == 10414 || status == 10415){
				return ['font-semibold text-electricGreen']
			} else if(status == 10416){
				return ['font-semibold text-primary']
			}else if(status == 10417 || status == 10418){
				return ['font-semibold text-darkred']
			}
		},
		colorAuditBg(status: any) {
			if (status == 10401) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10402 || status==10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403 ||status==10422) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10414 || status == 10415) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10416) {
				return ['evidenceUpload border-solid border border-primary'];
			}else if (status == 10417 || status == 10418) {
				return ['bg-veryHighColor border-solid border border-error'];
			} else {
				return '-'
			}
		},
		textColorForStatus(status: any) {
			if (status == 10403 || status==10422) {
				return ['font-semibold text-lightgreen'];
			} else if (status == 10402) {
				return ['font-semibold text-yellow'];
			} else if (status == 10401) {
				return ['font-semibold text-disabledgrey'];
			} else if (status == 10418){
				return ['font-semibold text-error']
			} else if(status==10421){
				return ['font-semibold text-yellow']
			}
		},
		bgColorForStatus(status: any) {
			if (status == 10403 || status==10422) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10402) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10401) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10418) {
				return ['bg-veryHighColor border-solid border border-error']
			} else if (status==10421) { 
			return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10420) { 				
				return ['bg-veryHighColor border-solid border border-darkred'];
			}
		},
		textColorForFindingStatus(status: any) {
			if (status == 10403 || status==10422) {
				return ['font-semibold text-lightgreen'];
			} else if (status == 10415 || status==10421) {
				return ['font-semibold text-yellow'];
			} else if (status == 10401) {
				return ['font-semibold text-disabledgrey'];;
			} else if (status == 10418) {
				return ['font-semibold text-error'];;
			} else if(status == 10402){
				return ['font-semibold text-electricGreen']
			} else if(status == 10406 || status == 10408){
				return ['font-semibold text-primary']
			} else if(status == 10419 ||status == 10414){
				return ['font-semibold text-forReview']
			}   else if(status == 10420){
				return ['font-semibold text-xs text-darkred']
			} else {
				return '-'
			}
		},
		bgColorForFindingStatus(status: any) {
			if (status == 10403 ||status==10422) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10415 || status==10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10401) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10418) {
				return ['bg-veryHighColor border-solid border border-error'];
			} else if (status == 10402) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10406 || status == 10408) {
				return ['evidenceUpload border-solid border border-primary'];
			}else if (status == 10419 || status == 10414) {
				return ['bg-forReviewBg border-solid border border-forReview'];
			} else if (status == 10420) {
				return ['bg-veryHighColor border-solid border border-darkred'];
			}else {
				return '-'
			}
		},
		isColumnPresentForLabel(column:any){
			if(column=='auditStatus'){
				return true
			}
		},
		initialize() {
			this.tableRow = this.tableRowData;
			this.searchTableRow = this.tableRowData;
		},
		paginationUpdations(currentPage: any, pageSize: any) {
			this.currentPage = currentPage;
			this.pageSize = pageSize;
		},
		sort(tableHead: any) {
			this.className = tableHead;
			if (tableHead == this.currentSort) {
				this.currentSortDir = this.currentSortDir == 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = tableHead;
			this.classSort = this.currentSortDir == 'asc' ? 'sort_asc' : 'sort_desc';
		},
		openPopup(data: any, index: any) {
			let popupdata = {
				entityData: data,
				indexx: index
			};
			emitter.emit('showData123', popupdata);
		},
		toolTip(column: any, e: any, index: any, row: any, status: any) {
			if (e.buttons) {
				this.doFalse();
				return;
			}
			this.tipText = (e.currentTarget?.textContent || row[column] || '').toString().trim();
			this.tipColumn = column;
			this.tipIndex = index;

			switch (status) {
				case 'text':
					this.handleTextTooltip(e);
					break;
				case 'circleButton':
					if (e.offsetX < e.target.offsetWidth && e.offsetY < e.target.offsetHeight) {
						let obj:any = {
							tipText : this.tipText
						}
                       emitter.emit('activiteToolTip',obj)
					}
			}
		},
		headerToolTip(column: any, e: any) {
			if (e.buttons) {
				this.doFalse();
				return;
			}
			const label = this.getColumnLabel(column);
			const container = e.currentTarget;
			if (label && container && this.isTextOverflowed(container)) {
				emitter.emit('activiteToolTip', { tipText: label });
			}
		},
		handleTextTooltip(e: any) {
			const container = e.currentTarget.classList?.contains('table-ellipsis')
				? e.currentTarget
				: e.currentTarget.closest('.table-ellipsis');
			if (container && this.isTextOverflowed(container)) {
				  let obj:any = {
						tipText : this.tipText
					}
                 emitter.emit('activiteToolTip',obj)
			}
		},
		isTextOverflowed(element: any) {
			return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
		},
		doFalse() {
			emitter.emit('deActiviteToolTip')
		},
		getOwnerType(input: any) {
			let type = this.orgType.find((l: any) => {
				return l.id == input;
			});
			if (type == undefined) {
				return input;
			} else {
				return type.value;
			}
		},
		getColumnLabel(columnName: any) {
			// console.log("sbjhsabhjhdsh",columnName)
			if (columnName == 'actionButtonAtAudits' || columnName == 'deleteIcon' ){
                return '';
            }
            const column = this.columns.find((col: { key: any }) => col.key === columnName);
            return column ? column.value : columnName;
        },
		isColumnArrayPresent(columnName: any) {
            // Returns true if the column name has corresponding dropdown options
            return this.dropdownOptions.some((option: { key: any }) => option.key === columnName);
        },
		getDropdownOptionsForFilter(columnName: any) {
            // console.log('sazxsadsad', columnName);
            const option = this.dropdownOptions.find((option: { key: any }) => option.key === columnName);
            return option ? option.value : [];
        },
		getStatusLabelFromColumn(columnName: any, type: any) {
            const option = this.dropdownOptions.find((option: { key: any }) => option.key === type);
            let option1 = option.value.find((soption: { id: any }) =>soption.id === columnName);
			if(option1 == undefined || option == undefined ||option == null || option1 == null ){
				option1 = '-'
			}
            // console.log('wasbdhjbdzjsad', option);
            // console.log('wasbdhjbdzjsad', option1);
            return option ? option1.value : [];
        },
		isFilterNotNecessary(columnName:any) {
            if(columnName == 'actionButtonAtAudits'  || columnName == 'deleteinfo' || columnName == 'startDate' || columnName == 'endDate' || columnName == 'auditPeriod' ||columnName == 'dueDate'|| columnName == 'statusCode' || columnName == 'auditStatus' || columnName=='findingStatus' || columnName == 'taskStatus' || columnName == 'findingCategory')
            {
                return true;
            }
			return false;
        },
		// shouldShowDisabled(columnName:any) {
        //     if(columnName == 'startDate' || columnName == 'endDate' || columnName == 'auditPeriod')
        //     {
        //         return true;
        //     }
            
        //         return false;  
        // },
		getLabelsArrayForColumnInStore(column: any){
			if(column == 'auditStatus'){
				return true
			} else{
				return false
			}
		},
		 getTeamName(ownerId: any) {
            let user = this.teamObject.find((obj: any) => {
                return obj.value == ownerId;
            });
            if (user == undefined) {
                let empty = '';
                return empty;
            } else {
                return user.label;
            }
        },
		 getLocationName(locationId: any) {
			if(locationId == 'Global'){
				return 'Global'
			}
			
            let user = this.locationObject.find((obj: any) => {
                return obj.value == locationId;
            });
            if (user == undefined) {
                let empty = 'N/A';
                return empty;
            } else {
                return user.label;
            }
        },
		getOwnerName(userId: any) {
            let user = this.optionsUserArray.find((obj: any) => {
                return obj.value == userId;
            });
            if (user == undefined) {
                let empty = 'N/A';
                return empty;
            } else {
                return user.label;
            }
        },
		checkuserData(column: any) {
            if (column == 'team' || column == 'entity' ) {
                return true;
            } else if(column == 'assignee'){
				return true;
			}
        },
		clickedOnActionButton(rowData: any, index: any, column: any) {
			this.doFalse();
			if(column!='deleteIcon'){
				emitter.emit('clickedOnTableRow',rowData)
			}
		},
		
		optionClickedOnAction(actionOption:any,rowData:any){
			let actionObj:any = {
				action: actionOption,
				data:rowData
			}
			if(rowData['auditStatus'] != 10401 && actionOption=='Edit'){
                toast.error('Cannot Edit Audit in this Status', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }else if(actionOption == 'Findings'){
				emitter.emit('openDetailsModal', {
					view: 'auditFindings',
					title: rowData.title || 'Audit Findings',
					params: { auditId: rowData._id },
				});
			}else{
                emitter.emit('clickedOnDropDownAction',actionObj)
            }
		},
		// optionClickedOnActionAtFindings(actionOption:any,rowData:any){
		// 	console.log('rowData',rowData)
		// 	if(actionOption == 'View'){
		// 		this.$router.push({ name: 'findingsInfo', params: { findingId: rowData._id } });
		// 	}
		// },
		// optionClickedOnActionAtActionTasks(actionOption:any,rowData:any){
		// 	console.log('rowData',rowData)
		// 	if(actionOption == 'View'){
		// 		this.$router.push({ name: 'findingTaskEdit', params: { taskId: rowData._id ,findingId : rowData.linkedFindingId} });
		// 	}
		// },
		// optionClickedOnActionAtControlsTasks(actionOption:any,rowData:any){
		// 	console.log('rowData',rowData)
		// 	if(actionOption == 'View'){
		// 		this.$router.push({ name: 'controlEdit', params: { taskId: rowData._id ,auditId : rowData.auditId} });
		// 	}
		// },
		async getAllUsers() {
            this.optionsUserArray = [];
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((result: any) => {
                // console.log('result of getAllUsers', result.data);
                result.data.map((obj: any) => {
                    let sendObj = {
                        value: obj._id,
                        label: obj.name
                    };
                    this.optionsUserArray.push(sendObj);
                    // console.log('getAllUsersListgetAllUsersListgetAllUsersList', this.optionsUserArray)
                });
            });
        },
		 async getallTeams() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.teamObject.push({ label: this.users[i].displayName, value: this.users[i]._id });
            }
        },
		 async getallEntities() {
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityDisplayName, value: result[i]._id });
            }
        },
		selectInputStyling(column: any){
			if(column == 'auditStatus' || column == 'findingStatus'){
				return 'widthFor1stAudit'
			}else if(column == 'taskStatus'){
				return 'statusWidthForTask'
			}else if(column == 'statusCode') {
				return 'widthForStatusCode'
			}
		},
		getColumnHeadWidth(column: any) {
			if (column == 'actionButtonAtAudits' || column == 'deleteIcon') {
				return 'actionButtonWidth';
			}
			if (column == 'title' || column == 'Title' || column == 'controlName' || column == 'findingComment' || column == 'action') {
				return 'titleColumnWidth';
			}
			if (column == 'auditStatus' || column == 'findingStatus' || column == 'taskStatus' || column == 'statusCode') {
				return 'statusColumnWidth';
			}
            let ValueKeys:any = ['frameWorkControl','frameworks','entityName','dueDate']
            if(ValueKeys.includes(column)){
               return 'w-28';
            }
			let ValueKeys1:any = ['findingCategory','teamName','auditor1','Status','controlNumber']
            if(ValueKeys1.includes(column)){
               return 'w-32';
            }
			let ValueKeys4:any = ['assignee','location','department','Frequency','auditPeriod']
            if(ValueKeys4.includes(column)){
               return 'w-36';
            }
			let ValueKeys5:any = ['teamName1','entityName1','auditee','auditor']
            if(ValueKeys5.includes(column)){
               return 'width25';
            }
			let ValueKeys6:any = ['auditName']
			if(ValueKeys6.includes(column)){
				return 'w-28'
			}
			let ValueKeys7:any = ['findingId','startDate','endDate','dueDate']
			if(ValueKeys7.includes(column)){
				return 'w-28'
			}

            else if( column=='taskId'|| column =='CID'){
                return 'w-20';
            }
			else if(column == 'TaskId' ||column=='auditId'){
				return 'w-24	'
			}
			else {
                return '';
            }
        },
		async getStatusesForEntity(entityId: string) {
			const appId = '10006';
			const result = await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`);
			return (result.data.statuses || []).map((s: any) => ({
				id: s.id,
				value: s.label
			}));
		},
		setDropdownOption(key: string, values: any[]) {
			const opt = this.dropdownOptions.find((o: any) => o.key === key);
			if (opt) {
				opt.value = values;
			}
		},
		async getFindingsStatuses() {
			const statuses = await this.getStatusesForEntity('10110');
			this.setDropdownOption('findingStatus', statuses);
		},
		async getCapaStatuses() {
			const statuses = await this.getStatusesForEntity('10119');
			this.setDropdownOption('statusCode', statuses);
		},
		async getAuditStatuses() {
			const statuses = await this.getStatusesForEntity('10117');
			this.setDropdownOption('auditStatus', statuses);
		},
		async getAuditTaskStatuses() {
			const statuses = await this.getStatusesForEntity('10118');
			this.setDropdownOption('taskStatus', statuses);
		},
	},
	async created(){
		await this.getAuditStatuses();
		await this.getFindingsStatuses();
		await this.getAuditTaskStatuses();
		await this.getCapaStatuses();
    },
});
</script>

